function dbtoBoolean(valor) {
    // eslint-disable-next-line eqeqeq
    if (valor == 1) {
        return true;
    } else {
        return false
    }
}

export default dbtoBoolean;